import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserOptionsComponent } from './user-options/user-options.component';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxTreeModule } from 'jqwidgets-ng/jqxtree';
import { FormsModule } from '@angular/forms';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxCheckBoxModule } from 'jqwidgets-ng/jqxcheckbox';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';

@NgModule({
  declarations: [UserOptionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxGridModule,
    jqxLoaderModule,
    jqxTreeModule,
    jqxButtonModule,
    jqxCheckBoxModule,
    jqxDropDownListModule,
  ],
  exports: [UserOptionsComponent],
})
export class UsersModule {}
